import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";
import {
  SupportRequestStatusType,
  SupportRequestTypeType,
} from "@/types/graphql/partner.generated";
import {
  REQUEST_STATUS_LABEL_KEY,
  REQUEST_TYPE_LABEL_KEY,
  useSupportRequestAssigneesQuery,
} from "@/partner/entities/assistant";
import { displayName } from "../model/thread";

// DRAFT/CANCELLED партнёр не видит; порядок как в работе с очередью.
const STATUS_OPTIONS = [
  SupportRequestStatusType.OpenType,
  SupportRequestStatusType.ViewerRepliedType,
  SupportRequestStatusType.WaitingViewerType,
  SupportRequestStatusType.ClosedType,
];

const TYPE_OPTIONS = Object.values(SupportRequestTypeType);

export const SupportRequestsFilter: FC = () => {
  const { t } = useTranslation();
  const assignees = useSupportRequestAssigneesQuery();

  return (
    <Filter
      title={t("requests.filterTitle")}
      fields={{ search: true }}
      selects={[
        {
          name: "needsReply",
          label: t("requests.filter.needsReply"),
          options: [
            { value: "true", label: t("requests.filter.needsReplyYes") },
          ],
        },
        {
          name: "status",
          label: t("requests.statusFilter"),
          options: STATUS_OPTIONS.map((value) => ({
            value,
            label: t(REQUEST_STATUS_LABEL_KEY[value]),
          })),
        },
        {
          name: "type",
          label: t("requests.typeFilter"),
          options: TYPE_OPTIONS.map((value) => ({
            value,
            label: t(REQUEST_TYPE_LABEL_KEY[value]),
          })),
        },
        {
          name: "assigneeId",
          label: t("requests.filter.assignee"),
          options: (assignees.data?.supportRequestAssignees ?? []).map((u) => ({
            value: u.id,
            label: displayName(u) ?? u.id,
          })),
        },
      ]}
    />
  );
};
